import { api } from "./client";

export type ExportFormat = "coco" | "yolo" | "voc" | "zip";
export interface SplitOptions { split: boolean; trainPct: number; valPct: number }

const splitQuery = (o: SplitOptions) =>
  o.split ? { split: "true", train_pct: o.trainPct, val_pct: o.valPct } : {};

/** What the desktop's save dialog proposes for each format (export_dialog.py ext_map). */
export function defaultFilename(fmt: ExportFormat, split: boolean): string {
  if (split && fmt === "coco") return "export_coco_split.zip";
  return { coco: "export_coco.json", yolo: "export_yolo.zip", voc: "export_voc.zip", zip: "dataset.zip" }[fmt];
}

/** Stored augmented copies (the Augment page): with the originals (null), left out, or on their own. */
export type AugmentedChoice = null | "exclude" | "only";

export function exportProject(pid: number, fmt: ExportFormat, o: SplitOptions, augmented: AugmentedChoice = null): Promise<Blob> {
  const aug = augmented ? { augmented } : {};
  if (fmt === "zip") return api.get<Blob>(`/projects/${pid}/export/zip`, { query: { ...splitQuery(o), ...aug }, as: "blob" });
  return api.get<Blob>(`/projects/${pid}/export`, { query: { format: fmt, ...splitQuery(o), ...aug }, as: "blob" });
}

/** Hand a blob to the browser as a download. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
